import Superagent from 'superagent'
import Storage from './storage.service'
import Access from '../$methods/access.methods'

const { HOST_API } = _CONSTANTS_

export default {
    getCoverageTil,
    uploadCoverageTil,
    downloadCoverageTil,
    getTilPricings,
    getTilPricing,
    createTilPricing,
    updateTilPricing,
    deleteTilPricing,
    uploadTilPricing,
    downloadTilPricing,
    getTrackingsTil,
    downloadTrackingsTil,
}

function getCoverageTil(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/til/coverage`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function uploadCoverageTil(data) {
    return new Promise((resolve, reject) => {
        Superagent
            .post(`${HOST_API}/til/coverage/upload`)
            .set('access', Storage.getItem('access'))
            .field('ownerId', data.ownerId)
            .attach('coverage', data.coverage)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function downloadCoverageTil(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/til/coverage/download`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .responseType('blob')
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getTilPricings(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/til/pricing`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function getTilPricing(pricingTilId) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/til/pricing/${pricingTilId}`)
            .set('access', Storage.getItem('access'))
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function createTilPricing(data) {
    return new Promise((resolve, reject) => {
        Superagent
            .post(`${HOST_API}/til/pricing`)
            .set('access', Storage.getItem('access'))
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function updateTilPricing(pricingTilId, data) {
    return new Promise((resolve, reject) => {
        Superagent
            .put(`${HOST_API}/til/pricing/${pricingTilId}`)
            .set('access', Storage.getItem('access'))
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function deleteTilPricing(pricingTilId) {
    return new Promise((resolve, reject) => {
        Superagent
            .delete(`${HOST_API}/til/pricing/${pricingTilId}`)
            .set('access', Storage.getItem('access'))
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function uploadTilPricing(data) {
    return new Promise((resolve, reject) => {
        Superagent
            .post(`${HOST_API}/til/pricing/upload`)
            .set('access', Storage.getItem('access'))
            .field('ownerId', data.ownerId)
            .attach('pricing', data.pricing)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function getTrackingsTil(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/til/trackings`)
            .set('access', Storage.getItem('access'))
            .query({
                dateStart: query.dateStart.toISOString(),
                dateEnd: query.dateEnd.toISOString(),
                timezone: new Date().getTimezoneOffset() / 60,
            })
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function downloadTrackingsTil(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/til/trackings/report`)
            .set('access', Storage.getItem('access'))
            .query({
                driverId: query.driverId,
                dateStart: query.dateStart.toISOString(),
                dateEnd: query.dateEnd.toISOString(),
                timezone: new Date().getTimezoneOffset() / 60,
            })
            .responseType('blob')
            .end((err, res) => {
                resolve(res && res.body)
            })
    })
}

function downloadTilPricing(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/til/pricing/download`)
            .set('access', Storage.getItem('access'))
            .query(query)
            .responseType('blob')
            .end((err, res) => {
                resolve(res.body)
            })
    })
}
